import { PARENT_RECORD_STATUS } from './constant';

/**
 * parent_record_status_changed is true when the saved parent record still
 * matches the TASS snapshot, and false when a parent-information field
 * (email, phone, address, etc.) has been edited.
 */
export const PARENT_RECORD_UNCHANGED = true;
export const PARENT_RECORD_CHANGED = false;

const normalizeText = (value) => String(value ?? '').trim();
const normalizeEmail = (value) => normalizeText(value).toLowerCase();
const normalizePhone = (value) => normalizeText(value).replace(/\s/g, '');

export const snapshotParentContactRecord = ({
    Email1 = '',
    Email2 = '',
    Number1 = '',
    Number2 = '',
    Town = '',
    State = '',
    Address1 = '',
    Address2 = '',
    Address3 = '',
    PostCode = '',
} = {}) => ({
    Email1: normalizeEmail(Email1),
    Email2: normalizeEmail(Email2),
    Number1: normalizePhone(Number1),
    Number2: normalizePhone(Number2),
    Town: normalizeText(Town).toLowerCase(),
    State: normalizeText(State).toUpperCase(),
    Address1: normalizeText(Address1).toLowerCase(),
    Address2: normalizeText(Address2).toLowerCase(),
    Address3: normalizeText(Address3).toLowerCase(),
    PostCode: normalizeText(PostCode),
});

export const hasParentContactChanged = (original, current) => {
    if (!original) {
        return false;
    }

    const fromTass = snapshotParentContactRecord(original);
    const fromForm = snapshotParentContactRecord(current);

    return Object.keys(fromTass).some((field) => fromTass[field] !== fromForm[field]);
};

export const getParentRecordStatusPayload = ({ hasChanged = false } = {}) => ({
    parent_record_status_changed: hasChanged ? PARENT_RECORD_CHANGED : PARENT_RECORD_UNCHANGED,
    parent_record_status: PARENT_RECORD_STATUS.PENDING,
});
